import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ children, requireDeveloper = false }) {
  const { isLoading: auth0Loading, isAuthenticated, loginWithRedirect } = useAuth0();
  const { user } = useAuth();
  const location = useLocation();

  // Wenn Auth0 sagt "nicht eingeloggt" → direkt zu Auth0 Universal Login
  useEffect(() => {
    if (!auth0Loading && !isAuthenticated) {
      loginWithRedirect({ appState: { returnTo: location.pathname } });
    }
  }, [auth0Loading, isAuthenticated, loginWithRedirect, location.pathname]);

  // Noch am Laden oder Redirect läuft
  if (auth0Loading || !isAuthenticated || user === undefined) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-rose-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Sync fehlgeschlagen
  if (!user) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center text-zinc-400">
        Anmeldung fehlgeschlagen – bitte erneut versuchen.
      </div>
    );
  }

  // Rolle prüfen
  if (user.role !== "developer" && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // Developer-only Seiten
  if (requireDeveloper && user.role !== "developer") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
}
